export const styles = {
    content: {
        position: 'relative',
        justifyContent: 'center',
    },
    trigger: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        backgroundColor: '#000',
        borderRadius: 50,
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 16,
        paddingRight: 6,
        cursor: 'pointer',
        userSelect: 'none',
    },
    triggerLabel: {
        color: 'white',
        fontWeight: '700',
        fontSize: 15,
        letterSpacing: 1,
    },
    flagCircle: {
        width: 36,
        height: 36,
        borderRadius: '50%',
        objectFit: 'cover',
    },
    dropdown: {
        position: 'absolute',
        right: 0,
        top: 50,
        width: 190,
        backgroundColor: 'white',
        padding: 2,
        borderRadius: 8,
        boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
        zIndex: 999,
    },
    dropdownItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        padding: 10,
        borderBottom: '1px solid #eee',
        cursor: 'pointer',
    },
    iconsSmall: {
        width: 24,
        height: 24,
        borderRadius: '50%',
        objectFit: 'cover',
    },
    text: {
        color: '#000',
        fontSize: 16,
        margin: 0,
    },
};
